import VueRoute from "../classes/VueRoute";
import {route} from "../functions/route";

export default {
	methods: {
		route(routeName, parameters, query) {
			return route(routeName, parameters, query);
		},
		buildRoute(name, parameters, query) {
			return new VueRoute(name, parameters, query);
		},
	},
};
